import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeMiterlimit: 10
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const
};

export const TicketIcon = createSvgIcon(
  <>
    <path
      d="M17.4043 6.59818C16.9957 6.18952 16.7565 5.6417 16.7345 5.06428C16.7125 4.48685 16.9092 3.9224 17.2854 3.48379C17.3165 3.44731 17.3327 3.40042 17.3307 3.35252C17.3287 3.30461 17.3087 3.25924 17.2746 3.22549L15.1075 1.05592C15.0717 1.02011 15.0231 1 14.9725 1C14.9218 1 14.8732 1.02011 14.8374 1.05592L11.3832 4.51014C11.2557 4.63753 11.1597 4.79289 11.1028 4.96389C11.0461 5.13526 10.9502 5.29106 10.8227 5.41892C10.6953 5.54678 10.5398 5.64319 10.3687 5.7005C10.1976 5.75751 10.0421 5.8535 9.91441 5.9809L1.05592 14.8374C1.02011 14.8732 1 14.9218 1 14.9725C1 15.0231 1.02011 15.0717 1.05592 15.1075L3.22303 17.2746C3.25678 17.3087 3.30216 17.3287 3.35006 17.3307C3.39797 17.3327 3.44486 17.3165 3.48133 17.2854C3.91985 16.9088 4.48443 16.7118 5.06205 16.7337C5.63967 16.7556 6.18771 16.9948 6.59644 17.4036C7.00517 17.8123 7.24444 18.3603 7.26635 18.9379C7.28825 19.5156 7.09117 20.0802 6.71457 20.5187C6.68345 20.5551 6.66728 20.602 6.66928 20.6499C6.67128 20.6978 6.69132 20.7432 6.72537 20.777L8.89248 22.9441C8.9283 22.9799 8.97688 23 9.02753 23C9.07818 23 9.12675 22.9799 9.16257 22.9441L18.0216 14.0856C18.149 13.9579 18.2449 13.8024 18.302 13.6313C18.3587 13.46 18.4546 13.3042 18.582 13.1763C18.7095 13.0485 18.8649 12.952 19.0361 12.8947C19.2071 12.8378 19.3625 12.7418 19.4899 12.6143L22.9441 9.16012C22.9799 9.12429 23 9.07572 23 9.02507C23 8.97442 22.9799 8.92585 22.9441 8.89003L20.777 6.72292C20.7432 6.68886 20.6978 6.66883 20.6499 6.66682C20.602 6.66482 20.5551 6.681 20.5187 6.71211C20.0807 7.08895 19.5166 7.28656 18.9391 7.26544C18.3617 7.24432 17.8136 7.00602 17.4043 6.59818Z"
      {...strokeProps}
    />
    <path
      d="M11.73 6.32505L10.9192 5.51428M13.8917 8.48675L13.351 7.94657M16.0534 10.649L15.5132 10.1083M18.4857 13.0808L17.6749 12.27"
      {...strokePropsRound}
    />
  </>,
  { displayName: 'TicketIcon', viewBox: '0 0 24 24' }
);
